import React, { useState } from 'react';

import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';

import Element from '../../../components/element';
import Button from '../../../components/Button';
import Flex from '../../../components/flex';
import Text from '../../../components/text';
import useStyles from './style';
import NonEditableSurvey from '../../Assessment/FormComponent/NonEditableSuvey';
import { colors } from '../../../config/theme';

const PreAssessments = () => {
  const classes = useStyles();
  const location = useLocation();
  //   const dispatch = useDispatch();
  const navigate = useNavigate();

  const { state } = location;
  const {
    visit,
    surveyDetails,
    sortedSurvey,
    lastUpdatedDate,
    assesmentValue
  } = state;

  const [assesmentTypeValue, setAssessmentValue] = useState(assesmentValue);

  const getAssesmentValue = e => {
    setAssessmentValue(e.target.value);
  };

  const navigateToAssesments = () => {
    navigate('/landing/pastvisits');
  };
  const navigateToIndividualVisit = () => {
    navigate('/landing/pastvisits/individualVisit', {
      replace: true,
      state: {
        visit: visit
      }
    });
  };

  return (
    <Element>
      <Element>
        <Flex marginBottom="20px">
          <Element onClick={navigateToAssesments}>
            <Text family="GTAR" size="14px" color={colors.dustyGray}>
              Past Visits
            </Text>
          </Element>
          <Element onClick={navigateToIndividualVisit}>
            <Text family="GTAR" size="14px" color={colors.dustyGray}>
              > Visit on {moment(visit.scheduledDate).format('MMMM Do, YYYY')}
            </Text>
          </Element>
          <Element>
            <Text family="GTAR" size="14px" color={colors.dustyGray}>
              > Pre-Visit Assessments
            </Text>
          </Element>
        </Flex>
      </Element>
      <Element className={classes.selectClass}>
        <label>Assessments</label>
        <select
          className={classes.selectOption}
          onChange={getAssesmentValue}
          value={assesmentTypeValue}
        >
          <option value="0">Family History</option>
          <option value="1">Social History</option>
          <option value="2">Medical History</option>
          <option value="3">Allergies & Medication</option>
          <option value="4">Sleep Quality</option>
          <option value="5">Physical Quality</option>
          <option value="6">Nutrition</option>
          <option value="7">Mental Health</option>
        </select>
      </Element>
      <NonEditableSurvey
        allSurveys={surveyDetails}
        sortedAssessments={sortedSurvey}
        surveysLastCompletedAt={lastUpdatedDate}
        survey={sortedSurvey[assesmentTypeValue]}
        closeAppointment={navigateToIndividualVisit}
      />
    </Element>
  );
};

export default PreAssessments;
